export default {
  PENDING: 'pending',
  LOADING: 'loading',
  DONE: 'done',
}
